import { render, staticRenderFns } from "./tippy-question.vue?vue&type=template&id=cbfd0290&"
import script from "./tippy-question.vue?vue&type=script&lang=js&"
export * from "./tippy-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports